import { ResumeSearchParameters as ResumeSearchParametersMapper, PathsGpptmIndexNameDocumentsPostRequestbodyContentApplicationJsonSchema as PathsGpptmIndexNameDocumentsPostRequestbodyContentApplicationJsonSchemaMapper } from "../models/mappers";
export const accept = {
    parameterPath: "accept",
    mapper: {
        defaultValue: "application/json",
        isConstant: true,
        serializedName: "Accept",
        type: {
            name: "String"
        }
    }
};
export const $host = {
    parameterPath: "$host",
    mapper: {
        serializedName: "$host",
        required: true,
        type: {
            name: "String"
        }
    },
    skipEncoding: true
};
export const offset = {
    parameterPath: ["options", "offset"],
    mapper: {
        constraints: {
            InclusiveMinimum: 0
        },
        serializedName: "offset",
        type: {
            name: "Number"
        }
    }
};
export const limit = {
    parameterPath: ["options", "limit"],
    mapper: {
        defaultValue: 300,
        constraints: {
            InclusiveMinimum: 1
        },
        serializedName: "limit",
        type: {
            name: "Number"
        }
    }
};
export const contentType = {
    parameterPath: ["options", "contentType"],
    mapper: {
        defaultValue: "multipart/form-data",
        isConstant: true,
        serializedName: "Content-Type",
        type: {
            name: "String"
        }
    }
};
export const file = {
    parameterPath: ["options", "file"],
    mapper: {
        serializedName: "file",
        type: {
            name: "Stream"
        }
    }
};
export const identifier = {
    parameterPath: ["options", "identifier"],
    mapper: {
        serializedName: "identifier",
        type: {
            name: "String"
        }
    }
};
export const fileName = {
    parameterPath: ["options", "fileName"],
    mapper: {
        serializedName: "fileName",
        type: {
            name: "String"
        }
    }
};
export const url = {
    parameterPath: ["options", "url"],
    mapper: {
        serializedName: "url",
        type: {
            name: "String"
        }
    }
};
export const wait = {
    parameterPath: ["options", "wait"],
    mapper: {
        defaultValue: "true",
        serializedName: "wait",
        type: {
            name: "String"
        }
    }
};
export const language = {
    parameterPath: ["options", "language"],
    mapper: {
        serializedName: "language",
        type: {
            name: "String"
        }
    }
};
export const expiryTime = {
    parameterPath: ["options", "expiryTime"],
    mapper: {
        serializedName: "expiryTime",
        type: {
            name: "String"
        }
    }
};
export const accept1 = {
    parameterPath: "accept",
    mapper: {
        defaultValue: "application/json",
        isConstant: true,
        serializedName: "Accept",
        type: {
            name: "String"
        }
    }
};
export const identifier1 = {
    parameterPath: "identifier",
    mapper: {
        serializedName: "identifier",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const redactHeadshot = {
    parameterPath: ["options", "redactHeadshot"],
    mapper: {
        defaultValue: "true",
        serializedName: "redactHeadshot",
        type: {
            name: "String"
        }
    }
};
export const redactPersonalDetails = {
    parameterPath: ["options", "redactPersonalDetails"],
    mapper: {
        defaultValue: "true",
        serializedName: "redactPersonalDetails",
        type: {
            name: "String"
        }
    }
};
export const redactWorkDetails = {
    parameterPath: ["options", "redactWorkDetails"],
    mapper: {
        defaultValue: "true",
        serializedName: "redactWorkDetails",
        type: {
            name: "String"
        }
    }
};
export const redactEducationDetails = {
    parameterPath: ["options", "redactEducationDetails"],
    mapper: {
        defaultValue: "true",
        serializedName: "redactEducationDetails",
        type: {
            name: "String"
        }
    }
};
export const redactReferees = {
    parameterPath: ["options", "redactReferees"],
    mapper: {
        defaultValue: "true",
        serializedName: "redactReferees",
        type: {
            name: "String"
        }
    }
};
export const redactLocations = {
    parameterPath: ["options", "redactLocations"],
    mapper: {
        defaultValue: "true",
        serializedName: "redactLocations",
        type: {
            name: "String"
        }
    }
};
export const redactDates = {
    parameterPath: ["options", "redactDates"],
    mapper: {
        defaultValue: "true",
        serializedName: "redactDates",
        type: {
            name: "String"
        }
    }
};
export const redactGender = {
    parameterPath: ["options", "redactGender"],
    mapper: {
        defaultValue: "true",
        serializedName: "redactGender",
        type: {
            name: "String"
        }
    }
};
export const resumeFormat = {
    parameterPath: "resumeFormat",
    mapper: {
        serializedName: "resumeFormat",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const contentType1 = {
    parameterPath: ["options", "contentType"],
    mapper: {
        defaultValue: "application/json",
        isConstant: true,
        serializedName: "Content-Type",
        type: {
            name: "String"
        }
    }
};
export const body = {
    parameterPath: "body",
    mapper: ResumeSearchParametersMapper
};
export const limit1 = {
    parameterPath: ["options", "limit"],
    mapper: {
        defaultValue: 20,
        constraints: {
            InclusiveMinimum: 1
        },
        serializedName: "limit",
        type: {
            name: "Number"
        }
    }
};
export const name = {
    parameterPath: ["options", "name"],
    mapper: {
        serializedName: "name",
        type: {
            name: "String"
        }
    }
};
export const name1 = {
    parameterPath: "name",
    mapper: {
        serializedName: "name",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const body1 = {
    parameterPath: "body",
    mapper: PathsGpptmIndexNameDocumentsPostRequestbodyContentApplicationJsonSchemaMapper
};
//# sourceMappingURL=parameters.js.map